/**
 * Date-extensions locale Bosnian [bs]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('bs', {
    monthNames: ['Januar','Februar','Mart','April','Maj','Juni','Juli','August','Septembar','Oktobar','Novembar','Decembar'],
    monthShortNames: ['Jan.','Feb.','Mar.','Apr.','Maj.','Jun.','Jul.','Aug.','Sep.','Okt.','Nov.','Dec.'],
    dayNames: ['Nedjelja','Ponedjeljak','Utorak','Srijeda','četvrtak','Petak','Subota'],
    dayShortNames: ['Ned.','Pon.','Uto.','Sri.','čet.','Pet.','Sub.']
});
